import { Controller } from "@hotwired/stimulus";

// Fetches a live preview of which extracted brands a candidate brand-regex
// will fold into the domain's canonical brand, so users can see its effect
// before saving the settings form.
export default class extends Controller {
  static targets = ["input", "result"];
  static values = { url: String };

  async test() {
    const pattern = this.hasInputTarget ? this.inputTarget.value.trim() : "";

    this.resultTarget.innerHTML =
      '<span class="loading loading-spinner loading-sm"></span>';

    const url = new URL(this.urlValue, window.location.origin);
    url.searchParams.set("brand_regex", pattern);

    try {
      const response = await fetch(url, {
        headers: { Accept: "text/html", "X-Requested-With": "XMLHttpRequest" },
      });
      this.resultTarget.innerHTML = await response.text();
    } catch (error) {
      this.resultTarget.innerHTML =
        '<div class="text-error text-sm">Preview failed. Please try again.</div>';
    }
  }
}
